import * as React from "react";
import padStart from "lodash/padStart";

const Progress = ({ current, total, css }) => {
  if (!current && !total) return null;
  return (
    <span className={css}>
      {padStart(current, 3, "0")}/{padStart(total, 3, "0")}
    </span>
  );
};

export default Progress;
